import { AgendaItem } from './agendaitem.class';

import { MeetingType } from '@orgbrain/lib-data';
import mongoose from 'mongoose';
import { Note, ProcedureType } from './lib-admin';

export class TimeOptionsForMeeting {
  modifiedBy: string;
  timeOptions: {
    _id?: string;
    startDate: string;
    endDate: string;
    userStatuses: Record<string, string>;
  }[];
  invitedUsers: string[];
  messageToInvited: string;
  timeToReplyBefore: string;
  updatedAt: string;
}
export type TimeOptionsForMeetingModelDocument = mongoose.HydratedDocument<TimeOptionsForMeeting>;

// Philip here it is
export class BoardMeetingCalendarEntry {
  _id: string = null;
  fullMeetingTitle?: string = '';
  title: string = null;
  number: number;
  locationName: string = null;
  status: string = null;
  isPartOfAnnualPlan = false;
  preVotingEnabled?: boolean;
  meetingCloneOf?: string;
  startDate: string | Date = null; // ISO date for meeting start time   TODO should be string.
  endDate: string | Date = null; // ISO date for meeting end time
  meetingType: MeetingType = null;
  procedureType: ProcedureType = null;
  agendaItems: AgendaItem[] = [];
  actionpoint?: boolean = false;
  followup?: boolean = false;
  meetingTimeOptions?: TimeOptionsForMeeting;
}

export class BoardMeetingSummary extends BoardMeetingCalendarEntry {
  notes: Note[] = [];
  comment: string = null;
  minutesGeneralComment: string = null;
  _typename?: string;
}

export class BoardMeeting extends BoardMeetingSummary {
  // startTime: string = null; // Just the time string compatible with the time drop down
  // endTime: string = null; // Just the time string compatible with the time drop down
  latitude: number = null;
  longitude: number = null;
  quorum: boolean = null;
  meetingLeader: string = null;
  agendaGeneralComments?: string;
  override fullMeetingTitle: string;
}
